import { fetchJSON } from "./utils";

export async function createBroadcastCampaign(data) {
  const url = `/api/broadcasts/campaigns`;
  return fetchJSON(url, null, data, "put");
}

export async function fetchBroadcastCampaigns(data) {
  const url = `/api/broadcasts/campaigns`;
  return fetchJSON(url, null, data, "post");
}

export async function fetchBroadcastCampaign(broadcast_id) {
  const url = `/api/broadcasts/campaigns/${broadcast_id}`;
  return fetchJSON(url, null, null, "get");
}
